module.exports = __webpack_public_path__ + "static/media/Sansa Stark 3.ad2bd8aa.jpg";